/* eslint-disable */
export const report = function (url) {
  const logs = [];
  const now = +new Date();
  const name = `log_${now}`;
  const img = (logs[name] = new Image());

  img.onload = img.onerror = function () {
    logs[name] = null;
  };

  url += (url.indexOf('?') > -1 ? '&' : '?') + now;

  img.src = url;

  return arguments;
};
